// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.0/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.0/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/PWSignaturetwo.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  color: white;
}

[dir] .tooltip .tooltip-inner {
  background: black;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  position: absolute;
  z-index: 1;
}

[dir] .tooltip .tooltip-arrow {
  border-style: solid;
  margin: 5px;
  border-color: black;
}

[dir] .tooltip[x-placement^=top] {
  margin-bottom: 5px;
}

.tooltip[x-placement^=top] .tooltip-arrow {
  bottom: -5px;
}

[dir] .tooltip[x-placement^=top] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-bottom-color: transparent !important;
  margin-top: 0;
  margin-bottom: 0;
}

[dir=ltr] .tooltip[x-placement^=top] .tooltip-arrow {
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  left: calc(50% - 5px);
}

[dir=rtl] .tooltip[x-placement^=top] .tooltip-arrow {
  border-right-color: transparent !important;
  border-left-color: transparent !important;
  right: calc(50% - 5px);
}

[dir] .tooltip[x-placement^=bottom] {
  margin-top: 5px;
}

.tooltip[x-placement^=bottom] .tooltip-arrow {
  top: -5px;
}

[dir] .tooltip[x-placement^=bottom] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-top-color: transparent !important;
  margin-top: 0;
  margin-bottom: 0;
}

[dir=ltr] .tooltip[x-placement^=bottom] .tooltip-arrow {
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  left: calc(50% - 5px);
}

[dir=rtl] .tooltip[x-placement^=bottom] .tooltip-arrow {
  border-right-color: transparent !important;
  border-left-color: transparent !important;
  right: calc(50% - 5px);
}

[dir=ltr] .tooltip[x-placement^=right] {
  margin-left: 5px;
}

[dir=rtl] .tooltip[x-placement^=right] {
  margin-right: 5px;
}

.tooltip[x-placement^=right] .tooltip-arrow {
  top: calc(50% - 5px);
}

[dir] .tooltip[x-placement^=right] .tooltip-arrow {
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
}

[dir=ltr] .tooltip[x-placement^=right] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  left: -5px;
  margin-left: 0;
  margin-right: 0;
}

[dir=rtl] .tooltip[x-placement^=right] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-right-color: transparent !important;
  right: -5px;
  margin-right: 0;
  margin-left: 0;
}

[dir=ltr] .tooltip[x-placement^=left] {
  margin-right: 5px;
}

[dir=rtl] .tooltip[x-placement^=left] {
  margin-left: 5px;
}

.tooltip[x-placement^=left] .tooltip-arrow {
  top: calc(50% - 5px);
}

[dir] .tooltip[x-placement^=left] .tooltip-arrow {
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
}

[dir=ltr] .tooltip[x-placement^=left] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-right-color: transparent !important;
  right: -5px;
  margin-left: 0;
  margin-right: 0;
}

[dir=rtl] .tooltip[x-placement^=left] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  left: -5px;
  margin-right: 0;
  margin-left: 0;
}

.tooltip.popover .popover-inner {
  color: black;
}

[dir] .tooltip.popover .popover-inner {
  background: #f9f9f9;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.1);
}

[dir] .tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden=true] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden=false] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}

.b-toast-primary .toast-header {
  color: #fff !important;
}

[dir] .b-toast-primary .toast-header {
  background-color: rgba(var(--vs-primary)) !important;
}

small.text-primary, div.text-primary, p.text-primary,
span.text-primary, h1.text-primary, h2.text-primary,
h3.text-primary, h4.text-primary, h5.text-primary {
  color: rgba(var(--vs-primary), 1) !important;
}

[dir] span.badge-primary {
  background-color: rgba(var(--vs-primary), 1) !important;
}

[dir] button.btn-primary {
  border-color: rgba(var(--vs-primary), 1) !important;
  background-color: rgba(var(--vs-primary), 1) !important;
}

.b-toast-primary .toast-header .close {
  color: white !important;
}

.vs-modal__container {
  overflow: visible !important;
}

.vs-modal__body {
  overflow-y: unset !important;
}

.vs-list--title {
  font-weight: normal;
}

.vs-list--subtitle {
  font-weight: 600;
}

.vs-popup--content {
  overflow-x: hidden !important;
}

.vs-table--tbody {
  z-index: 0 !important;
}

.tooltip {
  display: block !important;
  z-index: 100001;
}

[dir=ltr] .v-nav-menu .feather-icon {
  margin-right: 14px;
  margin-left: 14px;
}

[dir] .v-select.v-select-danger .vs__dropdown-toggle {
  border-color: var(--danger);
}

[dir] .v-select .vs__dropdown-toggle {
  background-color: #fff;
}

.vs-table--tbody-table .tr-values.hoverFlat:not(.activeEdit):not(.is-expand):hover {
  opacity: 1 !important;
}

@font-face {
  font-family: "PWSignaturetwo";

  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

[dir] label {
  margin-bottom: 7px !important;
}

.con-select .vs-select--input {
  height: 39px;
}

[dir] .con-select .vs-select--input {
  padding: 0.5rem;
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.con-text-validation .span-text-validation {
  font-size: 12px;
}

.moveable-control-box {
  --moveable-color: transparent !important;
}

textarea {
  resize: none !important;
}

.vs-textarea {
  resize: none !important;
}

.tags-input-badge {
  font-size: 12px !important;
}

[dir] .tags-input-remove:after {
  background: rgba(var(--vs-primary)) !important;
  margin-top: -1px;
}

[dir] .tags-input-remove:before {
  background: rgba(var(--vs-primary)) !important;
  margin-top: -1px;
}

.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  color: white;
}

[dir] .tooltip .tooltip-inner {
  background: black;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  position: absolute;
  z-index: 1;
}

[dir] .tooltip .tooltip-arrow {
  border-style: solid;
  margin: 5px;
  border-color: black;
}

[dir] .tooltip[x-placement^=top] {
  margin-bottom: 5px;
}

.tooltip[x-placement^=top] .tooltip-arrow {
  bottom: -5px;
}

[dir] .tooltip[x-placement^=top] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-bottom-color: transparent !important;
  margin-top: 0;
  margin-bottom: 0;
}

[dir=ltr] .tooltip[x-placement^=top] .tooltip-arrow {
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  left: calc(50% - 5px);
}

[dir=rtl] .tooltip[x-placement^=top] .tooltip-arrow {
  border-right-color: transparent !important;
  border-left-color: transparent !important;
  right: calc(50% - 5px);
}

[dir] .tooltip[x-placement^=bottom] {
  margin-top: 5px;
}

.tooltip[x-placement^=bottom] .tooltip-arrow {
  top: -5px;
}

[dir] .tooltip[x-placement^=bottom] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-top-color: transparent !important;
  margin-top: 0;
  margin-bottom: 0;
}

[dir=ltr] .tooltip[x-placement^=bottom] .tooltip-arrow {
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  left: calc(50% - 5px);
}

[dir=rtl] .tooltip[x-placement^=bottom] .tooltip-arrow {
  border-right-color: transparent !important;
  border-left-color: transparent !important;
  right: calc(50% - 5px);
}

[dir=ltr] .tooltip[x-placement^=right] {
  margin-left: 5px;
}

[dir=rtl] .tooltip[x-placement^=right] {
  margin-right: 5px;
}

.tooltip[x-placement^=right] .tooltip-arrow {
  top: calc(50% - 5px);
}

[dir] .tooltip[x-placement^=right] .tooltip-arrow {
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
}

[dir=ltr] .tooltip[x-placement^=right] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  left: -5px;
  margin-left: 0;
  margin-right: 0;
}

[dir=rtl] .tooltip[x-placement^=right] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-right-color: transparent !important;
  right: -5px;
  margin-right: 0;
  margin-left: 0;
}

[dir=ltr] .tooltip[x-placement^=left] {
  margin-right: 5px;
}

[dir=rtl] .tooltip[x-placement^=left] {
  margin-left: 5px;
}

.tooltip[x-placement^=left] .tooltip-arrow {
  top: calc(50% - 5px);
}

[dir] .tooltip[x-placement^=left] .tooltip-arrow {
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
}

[dir=ltr] .tooltip[x-placement^=left] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-right-color: transparent !important;
  right: -5px;
  margin-left: 0;
  margin-right: 0;
}

[dir=rtl] .tooltip[x-placement^=left] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  left: -5px;
  margin-right: 0;
  margin-left: 0;
}

.tooltip.popover .popover-inner {
  color: black;
}

[dir] .tooltip.popover .popover-inner {
  background: #f9f9f9;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.1);
}

[dir] .tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden=true] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden=false] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}

.modal-xl .modal-body {
  min-height: 70vh;
}

.modal-body .jsoneditor-vue {
  height: 65vh;
}

.modal-body .jsoneditor {
  height: 100%;
}

.modal-body .jsoneditor .jsoneditor-outer {
  height: calc(100% - 35px) !important;
}

.modal-body .ace-jsoneditor {
  height: 100% !important;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
